angular.module('propagandaManuscriptViewRequestModule', [])
    .controller('propagandaManuscriptViewRequestCtrl', ['$scope', 'trsHttpService', '$modalInstance', 'docid', 'modalDialog', 'title',
        function($scope, trsHttpService, $modalInstance, docid, modalDialog, title) {
            initStatus();
            initData();

            function initStatus() {
                $scope.data = {
                    detail: '',
                    title: title,
                }
            }

            function initData() {
                requestData();
            }

            /**
             * [requestData 获取上级要求]
             * @return {[type]} [description]
             */
            function requestData() {
                var params = {
                    serviceid: "mlf_pm",
                    methodname: "getDocRequirement",
                    mediaDocId: docid,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.CODE == 200) {
                        $scope.data.detail = data.DATA;
                    } else {
                        modalDialog.alertType(data.MESSAGE, '', 'warning', false, '');
                    }
                });
            }

            /**
             * [close 关闭]
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };

            $scope.confirm = function() {
                $modalInstance.close();
            };
        }
    ]);